import { LightingT } from "../types"

const lighting: LightingT = {
  shadow400: "2px 2px 0px 0px hsla(0,0%,0%,0.55)",
  shadow500: "4px 4px 0px 0px hsla(0,0%,0%,0.55)",
  shadow600: "8px 8px 0px 0px hsla(0,0%,0%,0.55)",
  shadow700: "10px 10px 0px 0px hsla(0,0%,0%,0.55)",
  overlay0: "inset 0 0 0 1000px hsla(0,0%,0%,0)",
  overlay100: "inset 0 0 0 1000px hsla(0,0%,0%,0.04)",
  overlay200: "inset 0 0 0 1000px hsla(0,0%,0%,0.08)",
  overlay300: "inset 0 0 0 1000px hsla(0,0%,0%,0.12)",
  overlay400: "inset 0 0 0 1000px hsla(0,0%,0%,0.16)",
  overlay500: "inset 0 0 0 1000px hsla(0,0%,0%,0.2)",
  overlay600: "inset 0 0 0 1000px hsla(0,0%,0%,0.24)",
}

export default lighting
